import RoleManagement from "../js/components/roleManagement/RoleManagement.react";
export default RoleManagement;
